var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "modal-dialog modal-small", attrs: { role: "document" } },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.data.title))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "section",
              [
                _c("section-title", {
                  attrs: { title: _vm.getSectionTitleName, fontweight: "bold" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("input", {
                      staticClass: "form-control",
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.data.title }
                    })
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              [
                _c("section-title", {
                  attrs: {
                    title: _vm.$t("message.getnotititle"),
                    fontweight: "bold"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.code, function(value, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-12 mt-2" },
                      [
                        _c(
                          "vs-checkbox",
                          {
                            staticStyle: { float: "left", margin: "0" },
                            attrs: { vsValue: value, color: "#A3CA76" },
                            model: {
                              value: _vm.form.code,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "code", $$v)
                              },
                              expression: "form.code"
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("notificationcode." + value)) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "vs-tooltip",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "5px"
                            },
                            attrs: {
                              text: _vm.$t("notificationcodedetail." + value),
                              position: "top"
                            }
                          },
                          [_c("i", { staticClass: "fas fa-info-circle" })]
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              [
                _c("section-title", {
                  attrs: { title: _vm.$t("message.status"), fontweight: "bold" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.active,
                            expression: "form.active"
                          }
                        ],
                        staticClass: "form-control custom-select",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "active",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { domProps: { value: true } }, [
                          _vm._v(_vm._s(_vm.$t("message.turnonnotification")))
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: false } }, [
                          _vm._v(_vm._s(_vm.$t("message.turoffnnotification")))
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-light",
                  attrs: {
                    disabled: _vm.$store.state.app.loading,
                    type: "button"
                  },
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("button.cancel")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              [
                _vm.$store.state.app.loading
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { disabled: true, type: "button" }
                      },
                      [_c("i", { staticClass: "fas fa-spinner spin" })]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-web",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.update()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.apply")) +
                            "\n          "
                        )
                      ]
                    )
              ]
            ],
            2
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c9016a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c9016a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/modal/channelnoti/Edit.vue
// module id = null
// module chunks = 